import { render } from "./DataPreparationSimple.vue?vue&type=template&id=04ed7fdc&scoped=true&ts=true"
import script from "./DataPreparationSimple.vue?vue&type=script&lang=ts"
export * from "./DataPreparationSimple.vue?vue&type=script&lang=ts"

import "./DataPreparationSimple.vue?vue&type=style&index=0&id=04ed7fdc&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ed7fdc"]])

export default __exports__